module.exports = __webpack_public_path__ + "img/i_filter.7a9ee320.svg";